module.exports = BVI18n;